import React from 'react';
import CleanroomRequirements from './CleanroomRequirements';


const Cleanroom = () => {
    return (
        <>

<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Clean Room</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
            <section>
           <div>
            <CleanroomRequirements/>
           </div>
            </section>
        </>
    );
};

export default Cleanroom;
